/**
 * @enum {string} HeadNavMenuConst
 * @description 头部导航菜单的常量枚举
 */
export const enum HeadNavMenuConst {
  /** 首页 */
  Home = 'home',
  /** 接入文档 */
  AccessDocument = 'document',
  /** 联系我们 */
  Contact = 'contact',
  /** 管理中心 */
  ControlCenter = 'controlCenter'
}

/**
 * @enum {string} ManagementMenuConst
 * @description 管理中心菜单的常量枚举
 */
export const enum ManagementMenuConst {
  /** 游戏管理 */
  GameManagement = 'gameManagement',
  /** 账号管理 */
  AccountManagement = 'accountManagement',
  /** 数据中心 */
  DataCenter = 'dataCenter',
  /** 结算中心 */
  SettlementCenter = 'settlementCenter'
  /** 汇率记录 */
  // ExchangeRateRecord = 'exchangeRateRecord'
}
